import styled from "styled-components";

export const Style = styled.div`
  .sideButtonWrap {
    margin-right: 4%;
    margin-bottom: 6%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 24px;
    z-index: 4;
  }
  .sideButton {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    height: 90px;
    background: linear-gradient(180deg, #48f8c9 0%, #65b6da 100%);
    border-radius: 100px;
    img {
      width: 70%;
      height: 70%;
    }
    img.siren {
      position: absolute;
      width: 14px !important;
      height: 14px !important;
      z-index: 3;
      right: 21px;
      bottom: 8px;
    }
    .count {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      position: absolute;
      top: 0;
      right: 0;
      background: #ffffff;
      border-radius: 50px;
      h3 {
        font-size: 18px;
        font-weight: 700;
        color: #4dd2ae;
      }
    }
    .request {
      position: absolute;
      bottom: -10px;
      background: #ffffff;
      border: 3px solid #65b6da;
      padding: 1px 8px;
      border-radius: 50px;
      p {
        font-size: 14px;
        line-height: 16px;
        color: #65b6da;
        font-weight: 500;
      }
    }
  }
  .sideButton.inactive {
    background: #a7a7a7;
  }

  .sideButton.contact {
    background: linear-gradient(180deg, #d186ff 0%, #8a9dff 100%);
    img {
      margin-top: -8px;
    }
    .count {
      top: 2px;
      right: 2px;
      width: 24px;
      height: 24px;
      background: #ff4a4a;
      h3 {
        font-size: 14px;
        font-weight: 700;
        color: #ffffff;
      }
    }
    .request {
      border-color: #8a9dff;
      p {
        color: #8a9dff;
      }
    }
  }
`;
